function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import isNaN from 'lodash/isNaN';
import { isDef } from '@cloud-sn/v-utils';
export { isNaN };
export function isNotCompleteNumber(v) {
  return isNaN(Number(v)) || v === '' || v === null || v === undefined || v && v.toString().slice('.') === v.length - 1;
}
export function getPrecision(val) {
  var defaultPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (defaultPrecision !== null) {
    return defaultPrecision;
  }

  var valStr = val.toString();
  var eDigit = 0;

  if (/e-/.test(valStr)) {
    var _valStr$split = valStr.split('e-');

    var _valStr$split2 = _slicedToArray(_valStr$split, 2);

    valStr = _valStr$split2[0];
    eDigit = _valStr$split2[1];
  }

  var decimal = 0;

  if (/\./.test(valStr)) {
    decimal = parseInt(valStr.split('.')[1].length, 10);
  }

  return decimal + eDigit;
}
export function getMaxPrecision(val, step) {
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var defaultPrecision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (defaultPrecision !== null) {
    return defaultPrecision;
  }

  var stepPrecision = getPrecision(step);
  var ratioPrecision = getPrecision(ratio);
  var valPrecision = getPrecision(val);
  return Math.max(valPrecision, stepPrecision + ratioPrecision);
}
export function getRatio(e) {
  var ratio = 1;

  if (e.metaKey || e.ctrlKey) {
    ratio = 0.1;
  } else if (e.shiftKey) {
    ratio = 10;
  }

  return ratio;
}
export function getValidateValue(val) {
  return !isDef(val) || val === '' ? undefined : Number(val);
}